class BannerSlider {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector('.banner-slider__track');
    this.slides = Array.from(el.querySelectorAll('.banner-slider__slide'));
    this.dots = Array.from(el.querySelectorAll('.banner-slider__dot'));
    this.prevBtn = el.querySelector('.banner-slider__arrow--prev');
    this.nextBtn = el.querySelector('.banner-slider__arrow--next');

    this.count = this.slides.length;
    if (this.count <= 1) return;

    this.index = 0;
    this.autoplay = el.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(el.dataset.autoplaySpeed, 10) || 5000;
    this.transitionSpeed = parseInt(el.dataset.transitionSpeed, 10) || 500;
    this.infinite = el.dataset.infinite === 'true';
    this.pauseOnHover = el.dataset.pauseHover === 'true';
    this.timer = null;

    this.track.style.transitionDuration = this.transitionSpeed + 'ms';

    this.bindEvents();
    this.goTo(0, false);
    if (this.autoplay) this.startAutoplay();
  }

  bindEvents() {
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.next();
        this.restartAutoplay();
      });
    }
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.prev();
        this.restartAutoplay();
      });
    }
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.goTo(parseInt(dot.dataset.index, 10));
        this.restartAutoplay();
      });
    });

    if (this.pauseOnHover) {
      this.el.addEventListener('mouseenter', () => this.stopAutoplay());
      this.el.addEventListener('mouseleave', () => {
        if (this.autoplay) this.startAutoplay();
      });
    }

    // Touch swipe support
    let startX = 0;
    let isDragging = false;
    this.track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    }, { passive: true });
    this.track.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      isDragging = false;
      const diff = e.changedTouches[0].clientX - startX;
      if (Math.abs(diff) > 40) {
        if (diff < 0) this.next();
        else this.prev();
        this.restartAutoplay();
      }
    });

    window.addEventListener('resize', () => this.goTo(this.index, false));
  }

  goTo(i, animate = true) {
    if (i < 0) i = this.infinite ? this.count - 1 : 0;
    if (i >= this.count) i = this.infinite ? 0 : this.count - 1;
    this.index = i;

    this.track.style.transitionDuration = animate ? this.transitionSpeed + 'ms' : '0ms';
    this.track.style.transform = `translateX(-${i * 100}%)`;

    this.dots.forEach((dot, idx) => {
      dot.classList.toggle('is-active', idx === i);
    });

    if (!this.infinite) {
      if (this.prevBtn) this.prevBtn.disabled = i === 0;
      if (this.nextBtn) this.nextBtn.disabled = i === this.count - 1;
    }
  }

  next() {
    this.goTo(this.index + 1);
  }

  prev() {
    this.goTo(this.index - 1);
  }

  startAutoplay() {
    this.stopAutoplay();
    this.timer = setInterval(() => this.next(), this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.timer) clearInterval(this.timer);
  }

  restartAutoplay() {
    if (this.autoplay) this.startAutoplay();
  }
}

function initBannerSliders() {
  document.querySelectorAll('.banner-slider').forEach((el) => {
    if (!el.dataset.initialized) {
      new BannerSlider(el);
      el.dataset.initialized = 'true';
    }
  });
}

document.addEventListener('DOMContentLoaded', initBannerSliders);
document.addEventListener('shopify:section:load', initBannerSliders);